import { UAContext } from '@quentin-sommer/react-useragent';
import * as Sentry from '@sentry/browser';
import { IncomingMessage } from 'http';
import { NextPage, NextPageContext } from 'next';
import React, { useContext } from 'react';
import { useAuth } from '~components/auth/provider';
import Button from '~components/button';
import Layout from '~components/layout';
import Typography from '~components/typography';
import { Router, useTranslation } from '~i18n';
import styles from '~public/styles/error.module.scss';
import { ImageError } from '~svg-components';
import { unifiedNavigate } from '~utils/unifiedNavigate';

const notifySentry = (
  err:
    | (Error & {
        statusCode?: number;
      })
    | null
    | undefined,
  req: IncomingMessage | undefined,
  statusCode: number | null | undefined
) => {
  Sentry.configureScope((scope: any) => {
    if (!req) {
      scope.setTag(`ssr`, false);
    } else {
      scope.setTag(`ssr`, true);
      scope.setExtra(`url`, req.url);
      scope.setExtra(`statusCode`, statusCode);
      scope.setExtra(`headers`, req.headers);
    }
  });

  Sentry.captureException(err);
};
interface ErrorProps {
  statusCode?: number | null;
}

const Error: NextPage<ErrorProps> = ({ statusCode }) => {
  const { t } = useTranslation();
  const token = useAuth();
  const uaResults = useContext(UAContext).uaResults as UAResults;
  const isMobile = uaResults.mobile;
  return (
    <Layout>
      <div className={styles.root}>
        <ImageError width={isMobile ? 200 : 380} height={isMobile ? 111 : 210} />
        <div className={styles.title}>
          <Typography variant="h4">{statusCode === 404 ? t('error.404') : ''}</Typography>
        </div>
        <Typography variant="body2">{t('error.description')}</Typography>
        <Button
          className={styles.btn}
          onClick={() => {
            if (token) {
              unifiedNavigate('/my-bookings');
            } else {
              unifiedNavigate('/login');
            }
          }}
        >
          {token ? t('error.view.my_bookings') : t('error.login')}
        </Button>
      </div>
    </Layout>
  );
};

Error.getInitialProps = async ({ req, res, err }: NextPageContext) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  notifySentry(err, req, statusCode);
  return {
    namespacesRequired: ['public'],
    statusCode,
  };
};

export default Error;
